import { Create, SimpleForm, TextInput } from 'react-admin';
import { Box } from '@mui/material';
import { layout } from '../styles/ds';

const validateCustomer = values => {
  if (!values.first_name?.trim() && !values.last_name?.trim() && !values.phone?.trim()) {
    return { first_name: 'נדרש לפחות שם פרטי, שם משפחה או טלפון' };
  }
  return {};
};

const CustomerCreate = () => (
  <Create title="לקוח חדש">
    <SimpleForm validate={validateCustomer}>
      <Box sx={layout.formGrid}>
        <TextInput source="first_name" label="שם פרטי"  fullWidth />
        <TextInput source="last_name"  label="שם משפחה" fullWidth />
        <TextInput source="phone"      label="טלפון"    fullWidth />
        <TextInput source="email"      label="אימייל"  fullWidth />
        <TextInput source="country"    label="מדינה"   fullWidth />
        <TextInput source="city"       label="עיר"     fullWidth />
      </Box>
      <TextInput source="address"          label="כתובת"          fullWidth />
      <TextInput source="shipping_address" label="כתובת למשלוח"  fullWidth />
    </SimpleForm>
  </Create>
);

export default CustomerCreate;
